<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="form">
    <nb-card-header
      ><h4>
        {{
          (data ? "dialogs.bucket.titleEdit" : "dialogs.bucket.titleCreate")
            | translate
        }}
      </h4></nb-card-header
    >
    <nb-card-body>
      <div class="form-group row">
        <label for="name" class="label col-sm-3 col-form-label">{{
          "input.name.label" | translate
        }}</label>
        <div class="col-sm-9">
          <input
            type="text"
            nbInput
            fullWidth
            id="name"
            placeholder="{{ 'input.name.placeholderBucket' | translate }}"
            formControlName="name"
            alAnchor="knowledge.bucket-name"
            [status]="showInputError('name') ? 'danger' : 'basic'"
          />
        </div>
      </div>
      <!--  -->
      <div class="form-group row">
        <label for="description" class="label col-sm-3 col-form-label">
          {{ "input.description.label" | translate }}
        </label>
        <div class="col-sm-9">
          <input
            type="text"
            nbInput
            fullWidth
            id="description"
            placeholder="{{
              'input.description.placeholderBucket' | translate
            }}"
            formControlName="description"
          />
        </div>
      </div>
      <!--  -->

      <!-- Access management — only when editing, admin/manager only. Grants a
           user access to this knowledge base (and any agent it feeds). -->
      <section *ngIf="canManageAccess" class="kb-access">
        <header class="kb-access__header">
          <h5>{{ "dialogs.bucket.access.title" | translate }}</h5>
          <p class="kb-access__hint">
            {{ "dialogs.bucket.access.hint" | translate }}
          </p>
        </header>

        <app-search-input
          class="kb-access__search"
          [(value)]="accessSearch"
          (valueChange)="onAccessSearchChange()"
        ></app-search-input>

        <div *ngIf="accessLoading" class="kb-access__loading">
          <nb-spinner status="primary"></nb-spinner>
        </div>

        <ul *ngIf="!accessLoading" class="kb-access__list">
          <li *ngFor="let row of pagedAccessRows" class="kb-access__row">
            <div class="kb-access__user">
              <span class="kb-access__name">{{
                row.user.name || row.user.email
              }}</span>
              <span class="kb-access__email" *ngIf="row.user.name">{{
                row.user.email
              }}</span>
            </div>
            <div class="kb-access__badges">
              <span
                class="kb-access__badge kb-access__badge--owner"
                *ngIf="row.isOwner"
                >{{ "pages.tutors.access.ownerBadge" | translate }}</span
              >
              <span
                class="kb-access__badge kb-access__badge--creator"
                *ngIf="row.isCreator && !row.isOwner"
                >{{ "pages.tutors.access.creatorBadge" | translate }}</span
              >
            </div>
            <nb-toggle
              [checked]="row.hasAccess || row.isOwner"
              [disabled]="row.isOwner || row.busy"
              (checkedChange)="toggleAccess(row)"
            ></nb-toggle>
          </li>
        </ul>

        <app-pagination
          *ngIf="!accessLoading && filteredAccessRows.length > accessPageSize"
          class="kb-access__pagination"
          [totalItems]="filteredAccessRows.length"
          [itemsPerPage]="accessPageSize"
          [currentPage]="accessPage"
          [pageSizeOptions]="accessPageSizeOptions"
          (pageChanged)="onAccessPageChange($event)"
          (itemsPerPageChange)="onAccessPageSizeChange($event)"
        ></app-pagination>
      </section>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="submit" nbButton status="primary" alAnchor="knowledge.bucket-save">
        {{ "buttons.save" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
